import { render, staticRenderFns } from "./header-web.vue?vue&type=template&id=047b4c66&scoped=true"
import script from "./header-web.vue?vue&type=script&lang=js"
export * from "./header-web.vue?vue&type=script&lang=js"
import style0 from "./header-web.vue?vue&type=style&index=0&id=047b4c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b4c66",
  null
  
)

export default component.exports